<div class="flex w-full min-h-screen max-h-screen flex-col md:flex-row">
    <div class="w-full md:w-1/2 bg-white flex min-h-screen md:min-h-0">
        <div class="w-full px-4 sm:px-6 py-8 md:px-12 lg:px-40 flex flex-col justify-center gap-6 md:gap-8 lg:gap-12">

            @if(tryAnotherWay){
            <div class="flex flex-col gap-3 md:gap-4">
                <div class="text-2xl sm:text-3xl md:text-4xl font-extrabold font-bricolage">
                    {{"Try Another way" | textCase}}
                </div>
                <span class="text-base sm:text-lg md:text-xl">{{"Choose any other method to login to your account" |
                    textCase}}</span>

                <div class="flex flex-col gap-2 w-full">
                    @for (item of availableMFAMethods; track $index) {
                    @if(item == PRIMARY_AUTH_METHODS.PASSKEYS){
                    <div (click)="chooseMFAMethod(PRIMARY_AUTH_METHODS.PASSKEYS)"
                        class="cursor-pointer p-3 md:p-4 w-full text-center rounded-xl border bg-gray-200 hover:bg-arena-orange-100 hover:border-arena-orange-300 transition-colors">
                        <div class="flex gap-3 md:gap-4 items-center">
                            <i class="pi pi-key p-2 text-lg md:text-xl"></i>
                            <div class="flex flex-col items-start">
                                <span class="text-sm md:text-base font-medium">{{"Passkeys" | textCase}}</span>
                                <small class="text-xs md:text-sm text-gray-800">{{"Try Using Passkeys to Authenticate" |
                                    textCase}}</small>
                            </div>
                        </div>
                    </div>
                    }
                    @if(item == PRIMARY_AUTH_METHODS.MFA){
                    <div (click)="chooseMFAMethod(PRIMARY_AUTH_METHODS.MFA)"
                        class="cursor-pointer p-3 md:p-4 w-full text-center rounded-xl border bg-gray-200 hover:bg-arena-orange-100 hover:border-arena-orange-300 transition-colors">
                        <div class="flex gap-3 md:gap-4 items-center">
                            <i class="pi pi-qrcode p-2 text-lg md:text-xl"></i>
                            <div class="flex flex-col items-start">
                                <span class="text-sm md:text-base font-medium">{{"Authenticator" | textCase}}</span>
                                <small class="text-xs md:text-sm text-gray-800">{{"Get a verification code" |
                                    textCase}}</small>
                            </div>
                        </div>
                    </div>
                    }
                    @if(item == PRIMARY_AUTH_METHODS.EMAIL_OTP){
                    <div (click)="chooseMFAMethod(PRIMARY_AUTH_METHODS.EMAIL_OTP)"
                        class="cursor-pointer p-3 md:p-4 w-full text-center rounded-xl border bg-gray-200 hover:bg-arena-orange-100 hover:border-arena-orange-300 transition-colors">
                        <div class="flex gap-3 md:gap-4 items-center">
                            <i class="pi pi-envelope p-2 text-lg md:text-xl"></i>
                            <div class="flex flex-col items-start">
                                <span class="text-sm md:text-base font-medium">{{"Email OTP" | textCase}}</span>
                                <small class="text-xs md:text-sm text-gray-800">{{"Get a verification code to the mail"
                                    | textCase}}</small>
                            </div>
                        </div>
                    </div>
                    }
                    }
                    @if(availableMFAMethods.length == 0){
                    <div class="flex flex-col gap-2 justify-start">
                        <span class="text-gray-500 text-sm md:text-base">{{"No other methods available" |
                            textCase}}</span>
                    </div>
                    }
                </div>

                <div class="mt-4 flex flex-col sm:flex-row justify-start gap-3 md:gap-4">
                    <app-button variant="filled" severity="primary" label="{{'Couldn\'t Find anything ?' | textCase}}"
                        (clicked)="redirect('/forgot-password')" class="w-full sm:w-auto" />
                    <app-button variant="filled" severity="contrast" label="{{'Go to Login' | textCase}}"
                        (clicked)="tryAgain()" class="w-full sm:w-auto" />
                </div>
            </div>
            }

            @else{
            @switch (currentAuthMethod) {
            @case ('MFA') {
            @if (mfaRegister) {
            <div class="flex flex-col gap-3 md:gap-4">
                <div class="text-2xl sm:text-3xl md:text-4xl font-extrabold font-bricolage">
                    {{"Register your account with MFA" | textCase}}
                </div>
                <span class="text-base sm:text-lg md:text-xl">{{"Scan the QR code with your authenticator app!" |
                    textCase}}</span>
                @if(mfaData){
                <div class="mt-4 flex justify-center">
                    <img class="w-48 md:w-64 rounded-xl border-4 border-gray-300" src="{{ mfaData.qrCode }}"
                        alt="QR Code">
                </div>
                }
                <div class="mt-3">
                    <app-button variant="filled" severity="primary" label="{{'Next' | textCase}}"
                        (clicked)="completeRegistration()" class="w-full" />
                </div>
                <div class="mt-6 text-center font-medium text-base">
                    <small class="cursor-pointer hover:text-orange-500">{{'Skip for now' | textCase}}</small>
                </div>
            </div>
            }
            @else if (mfaVerify) {
            <div class="flex flex-col gap-3 md:gap-4">
                <div class="text-2xl sm:text-3xl md:text-4xl font-extrabold font-bricolage">
                    {{'Verify your account' | textCase}}
                </div>
                <span class="text-base sm:text-lg md:text-xl">{{'Enter the code from your authenticator app!' |
                    textCase}}</span>
                <div class="flex flex-col gap-2">
                    <label class="text-sm text-gray-700 font-semibold" for="mfacode">{{'MFA Code' | textCase}}</label>
                    <input id="mfacode" class="input w-full" type="text" inputmode="numeric" pattern="\\d{6}"
                        maxlength="6" minlength="6" pInputText [(ngModel)]="mfaCode" placeholder="Enter your MFA Code"
                        required />
                    <app-button variant="filled" severity="primary" label="{{'Next' | textCase}}"
                        (clicked)="verifyMFA()" class="w-full" />
                </div>

                <div class="mt-4 flex flex-col sm:flex-row justify-center gap-3 md:gap-4">
                    <app-button variant="filled" severity="contrast" label="{{'Try Another way' | textCase}}"
                        (clicked)="tryAnotherWayFn()" class="w-full sm:w-auto" />
                    <app-button variant="filled" severity="primary" label="{{'Go to Login' | textCase}}"
                        (clicked)="tryAgain()" class="w-full sm:w-auto" />
                </div>
            </div>
            }
            }

            @case ('EMAIL_OTP') {
            <div class="flex flex-col gap-3 md:gap-4">
                <div class="text-2xl sm:text-3xl md:text-4xl font-extrabold font-bricolage">
                    {{'Verify your account' | textCase}}
                </div>
                <span class="text-base sm:text-lg md:text-xl">{{'Enter the code from your email!' | textCase}}</span>
                <div class="flex flex-col gap-2">
                    <div class="flex justify-between items-center">
                        <label class="text-sm text-gray-700 font-semibold" for="emailotp">{{"Email" |
                            textCase}} {{"OTP" | textCase:CASE_TYPE.UPPER}}</label>
                        <span class="text-xs text-gray-500">{{ maxOtpAttemptLimit - otpAttemptCount }} attempts
                            remaining</span>
                    </div>
                    <input id="emailotp" class="input w-full" type="text" inputmode="numeric" pattern="\\d{6}"
                        maxlength="6" minlength="6" pInputText [(ngModel)]="otpCode" placeholder="Enter your Email OTP"
                        required />
                    <app-button variant="filled" severity="primary" label="{{'Verify' | textCase}}"
                        (clicked)="verifyOTP(otpCode)" [disabled]="!otpCode" class="w-full" />
                </div>

                <div class="text-center font-medium text-base" (click)="canResendOTP && regenerateOTP()">
                    <small [class.cursor-pointer]="canResendOTP" [class.text-gray-400]="!canResendOTP"
                        [class.hover:text-orange-500]="canResendOTP" [class.cursor-wait]="!canResendOTP">
                        <ng-container *ngIf="canResendOTP; else timerDisplay">
                            <span *ngIf="!isOtpLoading">{{"Can't find the OTP?" | textCase}} {{"Regenerate Again" |
                                textCase}}</span>
                            <span *ngIf="isOtpLoading" class="text-gray-500">{{"Sending ..." | textCase}} {{"OTP" |
                                textCase:CASE_TYPE.UPPER}}...</span>
                        </ng-container>
                        <ng-template #timerDisplay>
                            <span class="text-gray-500 font-medium">{{"Resend OTP" | textCase}} ({{ resendTimer
                                }}s)</span>
                        </ng-template>
                    </small>
                </div>

                <div class="mt-4 flex flex-col sm:flex-row justify-center gap-3 md:gap-4">
                    <app-button variant="filled" severity="contrast" label="{{'Try Another way' | textCase}}"
                        (clicked)="tryAnotherWayFn()" class="w-full sm:w-auto" />
                    <app-button variant="filled" severity="primary" label="{{'Go to Login' | textCase}}"
                        (clicked)="tryAgain()" class="w-full sm:w-auto" />
                </div>
            </div>
            }

            @case ('PASSKEYS') {
            @if(passkeyAuthError){
            <div class="flex flex-col gap-6">
                <div class="flex flex-col sm:flex-row gap-6 md:gap-8 items-center">
                    <div class="flex justify-center items-center">
                        <i
                            class="pi pi-times text-red-500 text-4xl md:text-5xl border-2 border-red-500 p-3 md:p-4 rounded-xl"></i>
                    </div>
                    <div class="text-2xl md:text-4xl font-extrabold font-bricolage text-center sm:text-left">
                        {{'Something went wrong!' | textCase}}<br>
                        {{'Passkey Authentication Failed' | textCase}}
                    </div>
                </div>

                <div class="text-center font-medium text-base mt-4" (click)="tryAnotherWayFn()">
                    <small class="cursor-pointer">{{'Something\'s not working?' | textCase}} </small>
                    <small class="cursor-pointer hover:text-orange-500">{{'Try Another way' | textCase}}</small>
                </div>
                <div class="mt-4 flex justify-center">
                    <app-button variant="filled" severity="primary" label="{{'Go to Login' | textCase}}"
                        (clicked)="tryAgain()" class="w-full sm:w-auto" />
                </div>
            </div>
            }
            @else{
            <div class="flex flex-col gap-6">
                <div class="flex flex-col sm:flex-row gap-6 md:gap-8 items-center">
                    <div class="flex justify-center items-center">
                        <div class="relative flex justify-center items-center">
                            <p-progressSpinner class="w-16 h-16" strokeWidth="6" fill="var(--surface-ground)"
                                animationDuration=".5s" />
                            <i class="pi pi-key absolute w-4 h-4"></i>
                        </div>
                    </div>
                    <div class="text-2xl md:text-4xl font-extrabold font-bricolage text-center sm:text-left">
                        {{'Hold On,' | textCase}}<br>
                        {{'Completing your Passkey Authentication' | textCase}}
                    </div>
                </div>

                <div class="text-center font-medium text-base mt-4" (click)="tryAnotherWayFn()">
                    <small class="cursor-pointer">{{"Something's not working?" | textCase}} </small>
                    <small class="cursor-pointer hover:text-orange-500">{{"Try Another way" | textCase}}</small>
                </div>
            </div>
            }
            }

            @default {
            @if(thirdPartyAuthLoading){
            <div class="flex flex-col gap-6">
                <div class="flex flex-col sm:flex-row gap-6 md:gap-8 items-center">
                    <div class="flex justify-center items-center">
                        @if(error){
                        <i
                            class="pi pi-times text-red-500 text-4xl md:text-5xl border-2 border-red-500 p-3 md:p-4 rounded-xl"></i>
                        }
                        @else{
                        <div class="relative flex justify-center items-center">
                            <p-progressSpinner class="w-16 h-16" strokeWidth="6" fill="var(--surface-ground)"
                                animationDuration=".5s" />
                            @if(selectedAuthProvider == AUTH_PROVIDER.GOOGLE){
                            <img src="/icons/google-icon.svg" alt="google-icon" class="absolute w-4 h-4" />
                            }
                            @if(selectedAuthProvider == AUTH_PROVIDER.MICROSOFT){
                            <img src="/icons/microsoft.svg" alt="microsoft-icon" class="absolute w-4 h-4" />
                            }
                        </div>
                        }
                    </div>
                    <div class="text-2xl md:text-4xl font-extrabold font-bricolage text-center sm:text-left">
                        @if(error){
                        {{"Something went wrong!" | textCase}}<br>{{"Authentication Failed" | textCase}}
                        }
                        @else{
                        {{"Hold On," | textCase}}<br>{{"Authentication is in progress" | textCase}}
                        }
                    </div>
                </div>
                @if(error){
                <small class="text-gray-400 text-center text-xs md:text-sm">{{"ERR:" | textCase}}{{error}}</small>
                }

                <div class="text-center font-medium text-base mt-4">
                    <small class="cursor-pointer">{{"Something's not working?" | textCase}} </small>
                </div>
                <div class="mt-4 flex flex-col sm:flex-row justify-center gap-3 md:gap-4">
                    <app-button variant="filled" severity="primary" label="{{'Go to Login' | textCase}}"
                        (clicked)="tryAgain()" class="w-full sm:w-auto" />
                    <app-button variant="filled" severity="contrast" label="{{'Try Another way' | textCase}}"
                        (clicked)="tryAnotherWayFn()" class="w-full sm:w-auto" />
                </div>
            </div>
            }
            @else{
            <div class="flex flex-col gap-4 md:gap-6">
                <div class="text-2xl sm:text-3xl md:text-4xl font-extrabold font-bricolage">
                    {{"Welcome Back," | textCase}}<br>
                    {{"Sign-in to your account!" | textCase}}
                </div>
                <div class="text-sm md:text-base">{{"Don't have one?" | textCase}}
                    <span class="theme-text font-medium cursor-pointer" (click)="redirectToSignup()">
                        {{"Create an account" | textCase}}
                    </span>
                </div>

                <div class="flex items-center my-2">
                    <div class="flex-1 border-t border-gray-300"></div>
                    <span class="px-4 text-gray-500 text-sm">or</span>
                    <div class="flex-1 border-t border-gray-300"></div>
                </div>

                <div [formGroup]="loginForm" class="flex flex-col gap-4">
                    @if(loginStep === 1) {
                    <div class="flex flex-col gap-4">
                        <p class="flex items-center font-bold text-xl md:text-2xl gap-2 font-bricolage">
                            <span>{{"Login" | textCase}}</span>
                        </p>

                        <div class="flex flex-col">
                            <div class="flex justify-between items-center">
                                <label class="text-sm md:text-base text-gray-700 font-semibold" for="identifier">
                                    {{loginWith == LOGIN_WITH.EMAIL ? 'Email' : 'Username'}}
                                </label>
                                <p class="text-xs md:text-sm theme-text cursor-pointer" (click)="changeLoginWith()">
                                    {{"Login with " + (loginWith == LOGIN_WITH.EMAIL ? 'username' : 'email') |
                                    textCase}}
                                </p>
                            </div>
                            <app-input id="identifier" class="input w-full"
                                [type]="loginWith == LOGIN_WITH.EMAIL ? 'email' : 'text'" formControlName="identifier"
                                [placeholder]="'Enter your ' + (loginWith == LOGIN_WITH.EMAIL ? 'email' : 'username')"
                                (keydown.enter)="loginForm.get('identifier')?.valid && !isLoadingLoginMethods && onNext()"
                                [disabled]="isLoadingLoginMethods" />
                            @if(loginWith == LOGIN_WITH.EMAIL && loginForm.get('identifier')?.invalid &&
                            (loginForm.get('identifier')?.dirty || loginForm.get('identifier')?.touched)) {
                            <small class="text-red-500 text-xs mt-1">
                                @if(loginForm.get('identifier')?.errors?.['required']) {
                                {{"Email is required" | textCase}}
                                }
                                @if(loginForm.get('identifier')?.errors?.['email']) {
                                {{"Enter a valid email" | textCase}}
                                }
                            </small>
                            }
                        </div>

                        <app-button variant="filled" severity="primary"
                            [label]="isLoadingLoginMethods ? 'Verifying...' : 'Next' | textCase"
                            [disabled]="!loginForm.get('identifier')?.valid || isLoadingLoginMethods"
                            (clicked)="onNext()" [fullWidth]="true" />
                    </div>
                    }

                    @if(loginStep === 2) {
                    <div class="flex flex-col gap-4">
                        <div class="flex items-center gap-2 mb-2">
                            <i class="pi pi-arrow-left cursor-pointer text-lg" (click)="onBack()"></i>
                            <p class="flex items-center font-bold text-xl md:text-2xl gap-2 font-bricolage">
                                <span>{{"Login" | textCase}}</span>
                            </p>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm md:text-base text-gray-700 font-semibold" for="identifier-display">
                                {{loginWith == LOGIN_WITH.EMAIL ? 'Email' : 'Username'}}
                            </label>
                            <app-input id="identifier-display" class="input w-full"
                                [type]="loginWith == LOGIN_WITH.EMAIL ? 'email' : 'text'" formControlName="identifier"
                                [readonly]="true" />
                        </div>

                        @if(hasLoginMethod(LOGIN_METHOD.GOOGLE)) {
                        <div (click)="loginWithAuthProvider(AUTH_PROVIDER.GOOGLE)"
                            pTooltip="Use SSO only to log in to an existing account.">
                            <app-button variant="outlined" severity="contrast" [fullWidth]="true">
                                <div class="flex items-center gap-2 justify-center w-full">
                                    <img src="/icons/google-icon.svg" alt="google-icon" class="w-5 h-5">
                                    <span class="text-xs md:text-sm">{{"Login with" | textCase}} Google</span>
                                </div>
                            </app-button>
                        </div>
                        }

                        @if(hasLoginMethod(LOGIN_METHOD.MICROSOFT)) {
                        <div (click)="loginWithAuthProvider(AUTH_PROVIDER.MICROSOFT)"
                            pTooltip="Use SSO only to log in to an existing account.">
                            <app-button variant="outlined" severity="contrast" [fullWidth]="true">
                                <div class="flex items-center gap-2 justify-center w-full">
                                    <img src="/icons/microsoft.svg" alt="microsoft-icon" class="w-5 h-5">
                                    <span class="text-xs md:text-sm">{{"Login with" | textCase}} Microsoft</span>
                                </div>
                            </app-button>
                        </div>
                        }

                        @if(hasLoginMethod(LOGIN_METHOD.PASSWORD)) {
                        <div class="flex flex-col gap-4">
                            <div class="flex flex-col">
                                <label class="text-sm md:text-base text-gray-700 font-semibold" for="password">
                                    {{"Password" | textCase}}
                                </label>
                                <p-password id="password" placeholder="{{'Enter Password' | textCase}}"
                                    formControlName="password" [feedback]="false" [toggleMask]="true"
                                    (keydown.enter)="loginForm.valid && onSubmit()" styleClass="w-full"
                                    inputStyleClass="w-full rounded-base"></p-password>
                            </div>

                            <app-button variant="filled" severity="primary" label="{{'Login' | textCase}}"
                                [disabled]="!loginForm.valid" (clicked)="onSubmit()" [fullWidth]="true" />

                            <div class="text-center font-medium text-sm md:text-base" [routerLink]="'/forgot-password'">
                                <small class="cursor-pointer hover:text-orange-500">{{"Forgot password?" |
                                    textCase}}</small>
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
            }
            }
            }
            }
        </div>
    </div>

    <!-- Right Section - Hidden on mobile, visible on md+ -->
    <div class="hidden md:flex md:w-1/2 overflow-hidden">
        <img class="h-full w-full object-cover" [src]="'images/login-page.svg' | assetUrl" alt="login-image">
    </div>
</div>